// Helpers para construir el timetable de impresion del programa.

const pad2 = (n) => n.toString().padStart(2, '0')

// "07:00" -> { h: 7, m: 0 }
export const parseHora = (str) => {
  if (!str || typeof str !== 'string') return { h: 7, m: 0 }
  const parts = str.split(':')
  const h = parseInt(parts[0], 10)
  const m = parseInt(parts[1] || '0', 10)
  if (isNaN(h) || h < 0 || h > 23 || isNaN(m) || m < 0 || m > 59) {
    return { h: 7, m: 0 }
  }
  return { h, m }
}

// minutos totales desde 00:00 -> "HH:MM"
export const minutosToHHMM = (totalMin) => {
  const wrapped = ((totalMin % 1440) + 1440) % 1440 // normaliza si pasa de 24h
  const h = Math.floor(wrapped / 60)
  const m = wrapped % 60
  return `${pad2(h)}:${pad2(m)}`
}

// Construye el timetable: cada seccion con { inicio, fin, nombre, descripcion, tipo, duracion_seg, duracion_min }
// horaInicio: string "HH:MM" (ej "07:00")
// secciones: array con { nombre, duracion_seg, descripcion, tipo, orden }
export const buildTimetable = (horaInicio, secciones = []) => {
  const { h, m } = parseHora(horaInicio)
  let cursorMin = h * 60 + m
  return secciones.map((s, idx) => {
    const duracionSeg = s.duracion_seg || 0
    const duracionMin = Math.round(duracionSeg / 60)
    const inicio = minutosToHHMM(cursorMin)
    cursorMin += duracionMin
    const fin = minutosToHHMM(cursorMin)
    return {
      orden: s.orden || idx + 1,
      nombre: s.nombre || '',
      descripcion: s.descripcion || '',
      tipo: s.tipo || 'otro',
      duracion_seg: duracionSeg,
      duracion_min: duracionMin,
      inicio,
      fin,
      timetable: `${inicio}-${fin}`
    }
  })
}

// Duracion total formateada: "1h 30 min" o "45 min"
export const formatDuracionTotal = (secciones = []) => {
  const totalSeg = secciones.reduce((s, x) => s + (x.duracion_seg || 0), 0)
  const totalMin = Math.round(totalSeg / 60)
  if (totalMin >= 60) {
    const h = Math.floor(totalMin / 60)
    const m = totalMin % 60
    return m > 0 ? `${h}h ${m} min` : `${h}h`
  }
  return `${totalMin} min`
}
